import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "home",
    component: () =>{
      return  import("../views/HomeView.vue")
     }
  },
  {
    path: "/recharge",
    name: "recharge",
    component: () =>{
     return  import("../views/Recharge.vue")
    }
  },
  {
    path: "/iosHelp",
    name: "iosHelp",
    component: () =>{
     return  import("../views/iosHelp.vue")
    }
  },
  {
    path: "/iosAgreement",
    name: "iosAgreement",
    component: () =>{
     return  import("../views/iosAgreement.vue")
    }
  },
  {
    path: "/appRechargeAgreement",
    name: "appRechargeAgreement",
    component: () =>{
     return  import("../views/appRechargeAgreement.vue")
    }
  },
  {
    path: "/aboutView",
    name: "AboutView",
    component: () =>{
     return import("../views/AboutView.vue")
    }
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
